module.exports = __webpack_public_path__ + "static/gavilian-11e3e0a5b13b0260db963778ee4ef5af.png";